import React from "react";

interface FormFieldProps {
  label: string;
  name: string;
  type?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  required?: boolean;
}

/**
 * Reusable form field component with consistent styling
 * Label: 16px bold, Label-Input gap: 10px
 */
export default function FormField({
  label,
  name,
  type = "text",
  value,
  onChange,
  placeholder,
  required,
}: FormFieldProps) {
  return (
    <div>
      <label className="font-raleway mb-2.5 block text-base font-bold text-white">
        {label}
        {required && <span className="text-brand-red ml-1">*</span>}
      </label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className="font-raleway w-full rounded-full border border-white/30 bg-white/10 px-4 py-3 text-sm text-white placeholder-white/50 transition-all outline-none focus:border-white focus:bg-white/20"
      />
    </div>
  );
}
